module.exports = __webpack_public_path__ + "static/team4-cc8ffbece6d0c471ca51f8352309f7a8.jpg";